import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import RangeSlider from './RangeSlider';
import SelectCategory from './SelectCategory';
import PartnersCounter from './PartnersCounter';
import LocationAutoComplete from './LocationAutoComplete';
import MobileFilterToggler from './MobileFilterToggler';

const SearchArea: React.FC<Record<string, unknown>> = () => {
	const classes = useStyles();
	return (
		<Grid container spacing={2} justifyContent="space-between">
			<Grid item xs={9} lg={3}>
				<LocationAutoComplete />
			</Grid>
			<Grid item xs={3} lg={3} className={classes.hiddenOnDesktop}>
				<MobileFilterToggler />
			</Grid>
			<Grid item xs={3} className={classes.hiddenOnMobile}>
				<SelectCategory />
			</Grid>
			<Grid item xs={3} className={classes.hiddenOnMobile}>
				<RangeSlider />
			</Grid>
			<Grid item xs={3} className={classes.hiddenOnMobile}>
				<PartnersCounter />
			</Grid>
		</Grid>
	);
};

export default SearchArea;

const useStyles = makeStyles((theme) => ({
	hiddenOnMobile: {
		display: 'none',
		[theme.breakpoints.up('lg')]: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			maxWidth: '440px',
		},
	},
	hiddenOnDesktop: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		[theme.breakpoints.up('lg')]: {
			display: 'none',
		},
	},
}));
